import * as React from 'react';
import RootSeatInfoGroup from '@websky/core/src/SeatMap/components/SeatsInfo/SeatInfoGroup/SeatInfoGroup';
import { GdsSeatService } from '@websky/core/src/SeatMap/types';

const getSeatGroupKey = (service: GdsSeatService) => `${service.comfort}_${service.name}`;

const SeatInfoGroup: typeof RootSeatInfoGroup = props => (
	<RootSeatInfoGroup {...props} getSeatGroupKey={getSeatGroupKey} />
);

export default SeatInfoGroup;
